export default class works {
  constructor(el) {
    this.elm = el;
    this.init();
  }
  // タブとworkの一致
  categoryRemove() {
    // work一覧
    const works = document.querySelectorAll(`.p-works__item`);

    // 1つ1つ取得、一致したものを表示
    for(let i = 0; i < works.length; i++){
      let slugLabel = works[i].dataset.slug;
      document.querySelector(`.c-category__listItem[data-slug="${slugLabel}"]`).style.display = 'block';
    }

  }

  // タグ全体
  tagAll() {
    const items = document.querySelectorAll(`.p-works__item`);
    
    for(let i = 0; i < items.length; i++){
      items[i].style.display = 'block';
    }

  }

  // タグフィルター
  tagFilter(slugLabel) {
    const items = document.querySelectorAll(`.p-works__item`);
    for(let i = 0; i < items.length; i++){
      if (items[i].dataset.slug == slugLabel) {
        items[i].style.display = 'block';
      } else {
        items[i].style.display = 'none';
      }
    }
  }

  init() {
    this.elm.addEventListener('click', (e) => {
      let slugLabel = e.target.dataset.slug;
      // タブ全取得
      let categoryTabs = document.querySelectorAll(".c-category__listItem");

      // 1つ1つ取る、is-active外す
      for(let i = 0; i < categoryTabs.length; i++){
        categoryTabs[i].classList.remove('is-active');
      }

      // is-active付ける
      this.elm.classList.add('is-active');

      if(slugLabel == "all") {
        this.tagAll();
      } else {
        this.tagFilter(slugLabel);
      }
    }, false);

    this.categoryRemove();
  }
}